// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_j0-0";